export default "__VITE_ASSET__s5KwCH3M__"